import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Modal, Button } from "antd";
import "./RightsManager.css";

/**
 * Recorrido de bienvenida del Gestor.
 *
 * Se muestra una sola vez por navegador. No usa librería de tours: agregar una
 * dependencia obligaría a tocar el lock del proyecto para cuatro pantallas de
 * texto, y lo que hace falta acá es explicar qué hace la sección, no señalar
 * píxeles.
 *
 * La marca vive en localStorage y no en el backend a propósito: no haber visto
 * el tour no es un dato de la cuenta, y un usuario que cambia de máquina puede
 * verlo de nuevo sin que eso sea un problema. Si localStorage falla —modo
 * privado, cookies bloqueadas— el tour simplemente no se muestra: es una ayuda,
 * no algo que deba interrumpir el trabajo.
 */
const STORAGE_KEY = "bunkey.rightsManager.tourSeen";

const STEPS = [
  { title: "rights_tour_1_title", body: "rights_tour_1_body" },
  // El paso que explicaba "árbol vs lista" se quitó junto con el selector de
  // vista (punto 7 de Ricardo): ya no hay dos formas de mirar lo mismo.
  { title: "rights_tour_3_title", body: "rights_tour_3_body" },
  { title: "rights_tour_4_title", body: "rights_tour_4_body" }
];

export function shouldShowTour() {
  try {
    return !window.localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return false;
  }
}

class RightsManagerTour extends Component {
  state = { step: 0 };

  /**
   * Se marca visto al MOSTRARSE, no al cerrarse.
   *
   * Antes la marca se guardaba en handleClose, así que sólo contaba si el
   * usuario apretaba "Saltar" o "Entendido". Si se iba a otra pantalla con el
   * recorrido abierto —o cerraba la pestaña— no quedaba registro y el tour
   * volvía a aparecer en cada visita. Lo que hay que recordar es que ya se le
   * mostró, no que lo leyó hasta el final.
   */
  componentDidMount() {
    this.marcarVisto();
  }

  marcarVisto() {
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {
      // Sin localStorage el tour vuelve a aparecer en la próxima visita. Es
      // preferible a romper la pantalla por no poder guardar una preferencia.
    }
  }

  handleClose = () => {
    this.marcarVisto();
    this.props.onClose();
  };

  handleNext = () => {
    const { step } = this.state;
    if (step === STEPS.length - 1) {
      this.handleClose();
      return;
    }
    this.setState({ step: step + 1 });
  };

  render() {
    const { intl } = this.props;
    const { step } = this.state;
    const actual = STEPS[step];
    const ultimo = step === STEPS.length - 1;

    return (
      <Modal
        wrapClassName="rm-tour"
        visible
        onCancel={this.handleClose}
        width={480}
        footer={[
          <span className="rm-tour-dots" key="dots">
            {STEPS.map((_, i) => (
              <i key={i} className={i === step ? "on" : ""} />
            ))}
          </span>,
          <Button key="skip" onClick={this.handleClose}>
            {intl.formatMessage({ id: "rights_tour_skip" })}
          </Button>,
          <Button key="next" type="primary" onClick={this.handleNext}>
            {intl.formatMessage({
              id: ultimo ? "rights_tour_done" : "rights_tour_next"
            })}
          </Button>
        ]}
      >
        <h3 className="rm-tour-title">
          {intl.formatMessage({ id: actual.title })}
        </h3>
        <p className="rm-tour-body">{intl.formatMessage({ id: actual.body })}</p>
      </Modal>
    );
  }
}

export default injectIntl(RightsManagerTour);
